/* eslint-disable react/prop-types */
import getImages from '../../utils/GetImages';
import _ from '../../utils/LodashImports';
import { getMatchingVariants } from '../../utils/variant';
import BodyCopy from '../ui/BodyCopy/BodyCopy';
import CartItem from './CartItem/CartItem';

const mapItem = (item, regionCode, isCFMediasEnabled, mediaDomains) => {
  const { brand, displayName, id, prices, mediaUrls, sellerName } = item.product;

  const imageUrl = getImages({
    variantId: id,
    url: _.get(mediaUrls, '[0]', ''),
    sellerName,
    regionCode,
    isCFMediasEnabled,
    mediaDomains,
  });

  return {
    brandName: brand,
    name: displayName,
    skuId: id,
    image: imageUrl,
    productId: '',
    price: prices,
    totalQuantity: 0,
  };
};

const mapBundledItem =
  ({
    bundleItems,
    setBusy,
    textDictionary,
    removeProduct,
    setWarrantyOption,
    addProduct,
    limitAlerts,
    isCFMediasEnabled,
    regionCode,
    mediaDomains,
  }) =>
  (item) => {
    let isItemInCart = false;
    let bundleItem;

    bundleItems.forEach((bundle) => {
      const itemId = _.get(item, 'product.id', _.get(item, 'id', ''));
      if (!isItemInCart && bundle.skuId === itemId) {
        isItemInCart = true;
        bundleItem = bundle;
      }
    });

    return (
      <CartItem
        key={item.skuId || item.id}
        setBusy={setBusy}
        item={isItemInCart ? bundleItem : mapItem(item, regionCode, isCFMediasEnabled, mediaDomains)}
        textDictionary={textDictionary}
        onRemoveFromCart={removeProduct}
        showWarrantyOption={false}
        showAssemblyOption={false}
        setWarrantyOption={setWarrantyOption}
        onAddToCart={addProduct}
        type="bundle"
        isAtgPrice={!isItemInCart}
        limitAlerts={limitAlerts}
      />
    );
  };

const renderAddedBundle = ({
  labels,
  CartAddedBundleStyles,
  renderDescription,
  renderBrandName,
  bundleItems,
  isCFMediasEnabled,
  regionCode,
  mediaDomains,
}) => {
  return (
    <>
      <div className="added-bundles">
        <div className="header mkp">
          <i className="csicon-icon-success-circle">
            <span className="sr-only">{labels.ITEM_ADDED_A11Y_LABEL}</span>
          </i>
          <span className="label">
            {bundleItems.length} {labels.ITEM_ADDED_IN_CART}
          </span>
        </div>

        <div className="bundle-items">
          {bundleItems.map(({ brandName, name, skuId, sellerName, mediaUrls }) => {
            const imageUrl = getImages({
              variantId: skuId,
              url: _.get(mediaUrls, '[0]', ''),
              isCFMediasEnabled,
              regionCode,
              sellerName,
              mediaDomains,
            });
            return (
              <div className="bundle-item">
                <img src={imageUrl} width="50" height="50" alt={name} />
                <div className="item-info">
                  {renderBrandName(brandName)}
                  {renderDescription(name)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <style jsx>{CartAddedBundleStyles}</style>
    </>
  );
};

const renderBundleItem = ({
  bundledProductOrigin,
  bundles,
  labels,
  CartAddedBundleStyles,
  bundleItems,
  setBusy,
  textDictionary,
  removeProduct,
  setWarrantyOption,
  addProduct,
  renderDescription,
  renderBrandName,
  isTypeA,
  limitAlerts,
  isCFMediasEnabled,
  regionCode,
  mediaDomains,
}) => {
  if (isTypeA || !bundledProductOrigin) {
    return null;
  }

  if (bundledProductOrigin === 'CART') {
    return renderAddedBundle({
      labels,
      bundles,
      CartAddedBundleStyles,
      renderDescription,
      renderBrandName,
      bundleItems,
      isCFMediasEnabled,
      regionCode,
      mediaDomains,
    });
  }

  const renderBundledItem = mapBundledItem({
    bundleItems,
    setBusy,
    textDictionary,
    removeProduct,
    setWarrantyOption,
    addProduct,
    limitAlerts,
    isCFMediasEnabled,
    regionCode,
    mediaDomains,
  });
  return bundles.map(renderBundledItem);
};

const getTypeCollectionFromCart = (collection, variantId) => {
  for (let i = 0; i < collection.length; i += 1) {
    if (collection[i].skuId === variantId || collection[i].productId === variantId) {
      return collection[i];
    }
  }
  return null;
};

const isCollectionInMainSection = (cartItems, variantId) => {
  for (let i = 0; i < cartItems.length; i += 1) {
    if (cartItems[i].skuId === variantId) {
      return true;
    }
  }
  return false;
};

const renderCollections = ({
  labels,
  variants,
  colorCode,
  brandName,
  imageBaseURL,
  productId,
  setBusy,
  textDictionary,
  removeProduct,
  addProduct,
  cartItems,
  collection,
  limitAlerts,
}) => {
  const variantsToRender = getMatchingVariants(variants, {
    colorCode,
  }).filter((variant) => {
    const { id: skuId } = variant;

    return !isCollectionInMainSection(cartItems, skuId);
  });

  return (
    variantsToRender &&
    variantsToRender.length !== 0 && (
      <>
        <BodyCopy size="title14">{labels.MORE_PRODUCTS_FROM_COLLECTION}</BodyCopy>
        {variantsToRender.map((variant) => {
          const { name, id: skuId } = variant;

          const collectionItem = getTypeCollectionFromCart(collection, skuId);

          const item = {
            brandName,
            name,
            skuId,
            image: `${imageBaseURL}/${skuId}`,
            productId,
            price: variant.prices,
            totalQuantity: _.get(collectionItem, 'totalQuantity', -1),
            commerceItemId: _.get(collectionItem, 'commerceItemId', 0),
            addedQuantity: _.get(collectionItem, 'addedQuantity', 0),
            cartLineId: _.get(collectionItem, 'cartLineId', ''),
            offeringId: _.get(variant, 'offerings[0].offeringId', ''),
          };

          return (
            <CartItem
              key={skuId}
              setBusy={setBusy}
              item={item}
              textDictionary={textDictionary}
              onRemoveFromCart={removeProduct}
              showWarrantyOption={false}
              showAssemblyOption={false}
              onAddToCart={addProduct}
              isAtgPrice={false}
              limitAlerts={limitAlerts}
            />
          );
        })}
      </>
    )
  );
};

const getDefaultSelectedIndex = (options = []) => {
  for (let i = 0; i < options.length; i += 1) {
    if (options[i].selected) {
      return i;
    }
  }
  return -1;
};

const showWarningMessage = (stockUnits, cart) => {
  const { cartItems = [], bundleItems = [], typeACollections = [] } = cart;

  const products = [...cartItems, ...bundleItems, ...typeACollections];

  return !!products
    .filter((p) => p)
    .find((p) => {
      if (p.skuId && typeof stockUnits[p.skuId] !== 'undefined' && stockUnits[p.skuId] <= 3) {
        return true;
      }
      return false;
    });
};

let lastWarrantyTracking = {
  time: 0,
  source: '',
  trackingValue: '',
};

const trackWarrantySelection = (source, initialProductSku, warrantyName, warrantySku) => {
  let productSku = initialProductSku;

  if (!productSku) {
    const urlMatch = window.location.pathname.match(/\/product\/(\d+)/);
    if (urlMatch && urlMatch[1]) {
      [, productSku] = urlMatch;
    }
    if (!productSku && window.digitalData) {
      productSku =
        _.get(window.digitalData, 'product.productInfo.productID') || _.get(window.digitalData, 'product.productId');
    }
  }
  if (!source || !productSku || !warrantyName || warrantySku === undefined) {
    return;
  }
  const trackingValue = `|Warranty!${source}!${productSku}!${warrantyName}!${warrantySku}|`;
  const now = Date.now();
  const isRecentEvent = now - lastWarrantyTracking.time < 2000;
  const isSameWarranty = lastWarrantyTracking.trackingValue.includes(`!${productSku}!${warrantyName}!${warrantySku}`);
  let shouldTrack = true;

  if (isRecentEvent && isSameWarranty) {
    if (lastWarrantyTracking.source === 'PDP' && source === 'ModalPDP') {
      shouldTrack = true;
    } else if (lastWarrantyTracking.source === 'ModalPDP' && source === 'PDP') {
      shouldTrack = false;
    } else if (source === 'ModalA2C') {
      shouldTrack = true;
    } else if (lastWarrantyTracking.source === source) {
      shouldTrack = false;
    }
  }

  if (shouldTrack) {
    lastWarrantyTracking = {
      time: now,
      source,
      trackingValue,
    };
    if (window.digitalData && window.digitalData.tag && window.digitalData.tag.pdp) {
      window.digitalData.tag.pdp.warranty_tracking = trackingValue;
    }
    const eventToDigitalData = new CustomEvent('DDPDPWarrantySelection', {
      bubbles: true,
      detail: {
        payload: trackingValue,
      },
    });
    window.dispatchEvent(eventToDigitalData);
  }
};

export { getDefaultSelectedIndex, renderBundleItem, renderCollections, showWarningMessage, trackWarrantySelection };
